<script lang="ts" setup>
  import { computed, useId } from 'vue';
  import { FontIcon } from '../FontIcon';
  import {
    containerClass,
    containerEmptyClass,
    containerFilledClass,
    contentSlotClass,
    iconWrapperClass,
    messageClass,
    previewImageClass,
  } from './Preview.css';
  import type { PreviewProps } from './Preview.types';

  const props = defineProps<PreviewProps>();

  const uid = useId();
  const resolvedTestId = computed(() => props.testId ?? `ds-preview-${uid}`);

  const isEmpty = computed(() => !props.image);

  const containerClasses = computed(() => [
    containerClass,
    isEmpty.value ? containerEmptyClass : containerFilledClass,
  ]);
</script>

<template>
  <div
    :class="containerClasses"
    :data-testid="resolvedTestId"
    role="img"
    :aria-label="isEmpty ? text : alt"
  >
    <template v-if="isEmpty">
      <div :class="iconWrapperClass" aria-hidden="true">
        <FontIcon :icon-name="icon" />
      </div>
      <p :class="messageClass">{{ text }}</p>
    </template>
    <template v-else>
      <div :class="contentSlotClass">
        <img :src="image" :alt="alt" :class="previewImageClass">
      </div>
    </template>
  </div>
</template>
